module.exports = __webpack_public_path__ + "static/media/9.af1ddc8b.jpg";